import type { AppConfigInput } from 'nuxt/schema'

export default {
  tabs: {
    variants: {
      variant: {
        default: {
          trigger:
            'bg-none rounded-none border-b flex-1 justify-start data-[state=active]:text-(--black-primary) data-[state=inactive]:text-(--grey-secondary)  data-[state=active]:border-b-(--pink-primary)',
          label:
          'w-full text-left'
        },
      },
    },
  },
} as AppConfigInput['ui']
